import { Fire } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

import { POPULAR_ITEM_MINIMUM_SAVE_COUNT } from '@/components/ItemSave/ItemSave.constants';

type Props = {
    className?: string;
    savedCount: number;
    showSavedCount: boolean;
};

const ItemSaveBadge = ({ className, savedCount = 0, showSavedCount = false }: Props) => {
    if (showSavedCount && savedCount > 0) {
        return (
            <SaveLiveItem className={className}>
                <BodySecondary
                    className="flex items-center gap-2xs"
                    color="secondary"
                >
                    {savedCount >= POPULAR_ITEM_MINIMUM_SAVE_COUNT && (
                        <Fire
                            color="critical"
                            size="sm"
                            style="fill"
                        />
                    )}
                    <FormattedMessage
                        id="bidder_saved_item_count"
                        values={{ savedCount }}
                    />
                </BodySecondary>
            </SaveLiveItem>
        );
    }
    return null;
};

export default ItemSaveBadge;

const SaveLiveItem = styled.div`
    display: flex;
    flex-direction: column;
`;

SaveLiveItem.displayName = 'SaveLiveItem';
